'use strict';

import GenericTableData from './GenericTableData';

// Vendor Module Event Bus. Handles all interactions with Vendors.
let VendorData = GenericTableData.getTableDataBus('VENDOR', 'vendors');

VendorData.populateVendors = () => {
  VendorData.getAllRecords({ fields: 'name,status,tags' }).then((results) => {
    let fullVendorList = results?.records || [];
    VendorData.notifyListeners('ALL_VENDORS_LOADED', fullVendorList);
    return fullVendorList;
  });
};

VendorData.createVendor = (recordData) => {
  return VendorData.createRecord(recordData).then((results) => {
    VendorData.populateVendors();
    return results;
  });
};

export default VendorData;
